<template>
  <v-footer id="core-footer" absolute height="45">
    <div class="footer-items">
      <span v-for="link in links" :key="link.name">
        <a :href="link.link" target="_blank" class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { 
        name: 'Solution Coupons', 
        link: 'https://solution.coupons' 
      }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
